/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { ChangeEvent } from 'react'
import { FaUser, FaSearch } from 'react-icons/fa'
import { Divider } from '@material-ui/core'
import { Image, InputGroup, FormControl as BootStrapFormControl } from 'react-bootstrap'
import CompanyImg from '../../../../assets/img/gray_logo_icon.svg'
import 'bootstrap-daterangepicker/daterangepicker.css'

const ReportFilters = (props): JSX.Element => {
  const {
    currentStatus,
    status,
    handleStatusChange,
    currentType,
    handleTypeChange,
    isActiveCompany,
    setIsActiveCompany,
    isActiveUser,
    setIsActiveUser,
    contactsSearch,
    onContactsSearchChange,
  } = props
  const Types = ['All', 'REV-UP', 'ENGAGED', 'RE-ENGAGE']

  const handleCheckCompany = (): void => {
    setIsActiveCompany(!isActiveCompany)
  }

  const handleCheckUser = (): void => {
    setIsActiveUser(!isActiveUser)
  }

  return (
    <div className="report-filters">
      <div className="highlights">
        <div className="highlights-container">
          <p className="title">CONTACTS</p>
          <Image
            src={CompanyImg}
            alt="Placeholder"
            className={`avatar ${isActiveCompany ? 'active' : ''}`}
            roundedCircle
            onClick={handleCheckCompany}
          />
          <div
            role="button"
            tabIndex={0}
            className={`avatar-icon ${isActiveUser ? 'active' : ''}`}
            onClick={handleCheckUser}
            onKeyDown={(): void => {}}
          >
            <FaUser />
          </div>
          <Divider orientation="vertical" flexItem />
          {status.map(item => (
            <div
              role="button"
              tabIndex={0}
              className={`highlight ${currentStatus === item ? 'active' : ''}`}
              key={`engagement highlight - ${item}`}
              onClick={(): Promise<void> => handleStatusChange(item)}
              onKeyDown={(): void => {}}
            >
              {item}
            </div>
          ))}
        </div>
        <Divider orientation="vertical" flexItem />
        <div className="highlights-container type-section">
          <p className="title">MANEUVERS</p>
          <Divider orientation="vertical" flexItem />
          {Types.map((item, index) => (
            <div
              role="button"
              tabIndex={0}
              className={`
                highlight ${currentType === item ? 'active' : ''}
                ${index === Types.length - 1 ? 'no-border' : ''}
              `}
              key={`engagement highlight - ${item}`}
              onClick={(): Promise<void> => handleTypeChange(item)}
              onKeyDown={(): void => {}}
            >
              {item}
            </div>
          ))}
          <Divider orientation="vertical" flexItem />
          <InputGroup className="search-container">
            <FaSearch className="search-icon" />
            <BootStrapFormControl
              autoFocus
              type="text"
              min={1}
              placeholder="CONTACTS"
              value={contactsSearch}
              className="custom-day"
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onContactsSearchChange(e.currentTarget.value)
              }}
            />
          </InputGroup>
        </div>
      </div>
    </div>
  )
}

export default ReportFilters
